import api from '../config/api';
import { API_ENDPOINTS } from '../config/constants';

export const sellerService = {
  register: async (data) => {
    const response = await api.post(API_ENDPOINTS.SELLER_ONBOARDING.REGISTER, data);
    return response.data;
  },

  verifyOTP: async (phone, otp) => {
    const response = await api.post(API_ENDPOINTS.SELLER_ONBOARDING.VERIFY_OTP, { phone, otp });
    return response.data;
  },

  resendOTP: async (identifier, type = 'phone') => {
    const response = await api.post(API_ENDPOINTS.SELLER_ONBOARDING.RESEND_OTP, { identifier, type });
    return response.data;
  },

  getStatus: async () => {
    const response = await api.get(API_ENDPOINTS.SELLER_ONBOARDING.STATUS);
    return response.data;
  },

  completeProfile: async (formData) => {
    const response = await api.post(
      API_ENDPOINTS.SELLER_ONBOARDING.COMPLETE_PROFILE,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );
    return response.data;
  },

  submitForReview: async () => {
    const response = await api.post(API_ENDPOINTS.SELLER_ONBOARDING.SUBMIT);
    return response.data;
  },

  getProfile: async () => {
    const response = await api.get(API_ENDPOINTS.SELLER.PROFILE);
    return response.data;
  },

  // Added: was missing, referenced in Profile.jsx and Settings.jsx
  updateProfile: async (data) => {
    const response = await api.put(API_ENDPOINTS.SELLER.UPDATE_PROFILE, data);
    return response.data;
  },

  getDashboard: async () => {
    const response = await api.get(API_ENDPOINTS.SELLER.DASHBOARD);
    return response.data;
  },
};

export default sellerService;